import { render, staticRenderFns } from "./ybsf.vue?vue&type=template&id=2eb888e4&"
import script from "./ybsf.vue?vue&type=script&lang=js&"
export * from "./ybsf.vue?vue&type=script&lang=js&"
import style0 from "./ybsf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports